import React from "react"
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom'
import SubscriptionCheckoutPage from './components/SubscriptionCheckoutPage'
import FilmmakerBackground from './components/FilmmakerBackground'
import DistributorBackground from './components/DistributorBackground'
import AudienceBackground from './components/AudienceBackground'

export default function App() {
  return (
    
    <Router>
      <Switch>
        <Route exact path = "/">
          <FilmmakerBackground/>
          <SubscriptionCheckoutPage subscriptionType = "filmmaker"/>
        </Route>
        <Route exact path = "/filmmaker">
          <FilmmakerBackground/>
          <SubscriptionCheckoutPage subscriptionType = "filmmaker"/>
        </Route>
        <Route exact path = "/audience">
          <AudienceBackground/>
          <SubscriptionCheckoutPage subscriptionType = "audience"/>
        </Route>
        <Route exact path = "/distributor">
          <DistributorBackground/>
          <SubscriptionCheckoutPage subscriptionType = "distributor"/>
        </Route>
      </Switch>


      </Router>
    

    // "/short-film"
    // 
    // "/student-film"
  );
}
